<template>
    <div>
      <Head>
        <title>BacktoWorkConnect.ie - Ireland's leading career hub for Returners and career changers</title>
        <link rel="canonical" href="https://backtoworkconnect.ie" />
      </Head>
      <TabbedSearch :baseurl="baseurl" :locations="locations" :categories="categories" :clearbg="true"></TabbedSearch>
      <v-container style="margin-top:15px;margin-bottom:15px;">
        <v-row>
          <v-col cols="12" lg="12" class="text-center">
            <span class="primary--text display-1 ">We’re a Returner Friendly Employer</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" lg="12">
            <v-slide-group
              show-arrows
            >
              <v-slide-item
                v-for="o in organizations"
                :key="o.id"
                v-slot="{ active, toggle }"
                style="max-width:150px;max-height:150px;padding-left:3px;padding-right:3px"
                @click="alert('click')"
              >
                <a :href="'/organization/'+o.alias">
                  <v-img :src="baseurl + '/img/' + o.photo_path" 
                  style="max-width:146px;max-height:150px"></v-img>
                </a>
              </v-slide-item>
            </v-slide-group>
          </v-col>
        </v-row>
      </v-container>
      <v-container>
        <v-row>
          <v-col cols="12" lg="4" md="12">
            <v-card>
              <a href="https://backtoworkconnect.ie/careerhub/supports/" target="_blank">
                <v-img
                  src="/img/Membership.webp"
                  class="white--text align-end"
                  gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                  height="200px"
                >
                  <v-card-title>Membership</v-card-title>
                </v-img>
              </a>
            </v-card>
            
          </v-col>
          <v-col cols="12" lg="4" md="12">
            
              <v-card>
                <a href="/events" as="button">
                    <v-img
                      src="/img/Events-Square400x400.webp"
                      class="white--text align-end"
                      gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                      height="200px"
                    >
                      <v-card-title>Events</v-card-title>
                    </v-img>
                  </a>
              </v-card>
          </v-col>
          <v-col cols="12" lg="4" md="12">
            <v-card>
              <a href="https://backtoworkconnect.ie/careerhub/series/back-to-work-connect-the-podcast/" target="_blank">
                <v-img
                  src="img/Podcast400x400.webp"
                  class="white--text align-end"
                  gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                  height="200px"
                >
                  <v-card-title>Podcast</v-card-title>
                </v-img>
              </a>
            </v-card>
            
          </v-col>
        </v-row>
      </v-container>
      
      <v-container fluid>
      <v-row align="center" justify="center" class="mt-5 top-border-purple">
        <v-col cols="10">
          <v-row align="center" justify="center">
            <v-col cols="12" sm="6" class="hidden-sm-and-down">
              <v-img src="/img/Career Sectors400x400.webp" class="d-block ml-auto mr-auto" max-width="350px" />
            </v-col>
            <v-col cols="12" sm="6" class="primary--text text-left ">
              <h1 class="font-weight-light display-2 mb-2">Career Advice</h1>
              <v-img src="/img/Career Sectors400x400.webp" class="hidden-md-and-up ml-auto mr-auto" max-width="350px" />
              <h1 class="font-weight-light black--text">
                Changing career or returning to work but not sure where to begin? Explore the career choices and professions that could be right for you.
              </h1>
              
              <a href=" https://backtoworkconnect.ie/careerhub/blog/" target="_blank">
                <v-btn rounded outlined href="/careerhub" target="_blank" large color="primary" class="mt-4">
                  <v-icon class="mr-2">
                    mdi-briefcase
                  </v-icon>
                  Find out more
                </v-btn>
              </a>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid>
      <v-row align="center" justify="center" class="mt-5 top-border-purple">
        <v-col cols="10">
          <v-row align="center" justify="center">
            <v-col cols="12" sm="6" class="primary--text text-left ">
              <h1 class="font-weight-light display-2 mb-2">Interested in getting your business involved with us?</h1>
              <v-img src="/img/Interested-in-getting-your-business-involved-with-us711x400.webp" class="ml-auto mr-auto hidden-md-and-up" max-width="350px" />
              <h1 class="font-weight-light black--text">
                We partner with forward-thinking organisations nationwide to design and create supportive & impactful return to work initiatives and ultimately promote truly inclusive work environments for all.
              </h1>
              <a href="https://backtoworkconnect.ie/careerhub/advertising-with-us/" target="_blank">
                <v-btn rounded outlined href="https://backtoworkconnect.ie/careerhub/advertising-with-us/" target="_blank" large color="primary" class="mt-4">
                  <v-icon class="mr-2">
                    mdi-page-next-outline
                  </v-icon>
                  Find out more
                </v-btn>
              </a>
            </v-col>
            
            <v-col cols="12" sm="6" class="hidden-sm-and-down">
              <v-img src="/img/Interested-in-getting-your-business-involved-with-us711x400.webp" class="ml-auto mr-auto" max-width="350px" />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
      <v-container fluid>
      <v-row align="center" justify="center" class="mt-5 top-border-purple">
        <v-col cols="10">
          <v-row align="center" justify="center">
            <v-col sm="4" class="hidden-sm-and-down"> 
              <v-img src="/img/How-Returner-Friendly-is-your-organisation-711x400.webp" class="ml-auto mr-auto" max-width="350px" />   
            </v-col>
            <v-col cols="12" sm="8" class="primary--text text-left ">
              <h1 class="font-weight-light display-2 mb-2">How returner friendly is your organization?</h1>
              <v-img src="/img/How-Returner-Friendly-is-your-organisation-711x400.webp" class="ml-auto mr-auto hidden-md-and-up" max-width="350px" /> 
              
              <h1 class="font-weight-light black--text">
                If you’re ready to reap the many benefits the returner can bring to your organisations, we invite you to take part in our brand-new interactive quiz:
              </h1>
              <a href="https://us20.list-manage.com/survey?u=b14e986a20d3ea1877fdd1281&id=e3535d1515&attribution=false">
                <v-btn rounded outlined href="https://us20.list-manage.com/survey?u=b14e986a20d3ea1877fdd1281&id=e3535d1515&attribution=false" target="_blank" large color="primary" class="mt-4">
                  <v-icon class="mr-2">
                    mdi-help-box-multiple
                  </v-icon>
                  Take the Quiz
                </v-btn>
              </a>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>

    
    <v-container>
      <v-row>
        <v-col cols="12" lg="12" style="background-color:#560354 !important" class="white--text mt-5 text-center overline"><span class="text-lg-h5 text-md-h6">Supported By</span></v-col>
      </v-row>
      <v-row>
        <v-col cols="12" lg="2"><v-img max-width="300" src="/img/REthink-300x300.jpg"></v-img></v-col>
        <v-col cols="12" lg="2"><v-img max-width="300" src="/img/DC-LEO-300x300.jpg"></v-img></v-col>
        <v-col cols="12" lg="2"><v-img max-width="300" src="/img/cfi-300x300.jpg"></v-img></v-col>
        <v-col cols="12" lg="2"><v-img max-width="300" src="/img/boi-300x300.jpg"></v-img></v-col>
        <v-col cols="12" lg="2"><v-img max-width="300" src="/img/rte-300x300.jpg"></v-img></v-col>
        <v-col cols="12" lg="2"><v-img max-width="300" src="/img/EI-300x300-2.jpg"></v-img></v-col>
      </v-row>
    </v-container>
    </div>
  </template>
  
  <script>
  import { Head, Link } from '@inertiajs/inertia-vue' 
  import Layout from '@/Shared/VuetifyLayout'
  import TabbedSearch from '@/Shared/TabbedSearch'
  
  export default {
    props: {
      locations: Array,
      categories: Array,
      organizations: Array,
      baseurl: String,
      auth: Object,
    },
    components: {
      Head,
      TabbedSearch
    },
    layout: Layout,
    data() {
        return {
            keyword: "",
            location: "",
            category: "",
        }
    },
    mounted() {
      console.log('mounted',this.auth)
      if (!this.auth || !this.auth.user)
      {
        console.log('deleting cookie')
        this.setCookie('ltoken',0,-1,'','/');
      }
    },
    methods: {
      searchJobs() {
        this.$inertia.get(this.baseurl+'/search/job', {keyword: this.keyword, location: this.location, category: this.category}, {

        }) 
      },
      setCookie(name, value, expiryDays, domain, path) {
        const exdate = new Date()
        exdate.setDate(exdate.getDate() + (expiryDays || 365))
        const cookie = [
        `${name}=${value}`,
        `expires=${exdate.toUTCString()}`,
        `path=${(path || '/')}`
        ]
        if (domain) {
        cookie.push(`domain=${domain}`)
        }
        document.cookie = cookie.join(';')
      }
    }
  }
  </script>
  